var render = function render(){var _vm=this,_c=_vm._self._c;return _c('t-datepicker',{attrs:{"value":_vm.value,"name":_vm.name,"weekStart":_vm.weekStart}})
}
var staticRenderFns = []

export { render, staticRenderFns }